import React, { SVGProps } from 'react'

const ArrowUpIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='12'
      viewBox='0 0 12 8'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.41 7.41L6 2.83L10.59 7.41L12 6L6 -2.62268e-07L-2.62268e-07 6L1.41 7.41Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default ArrowUpIcon
